import * as React from 'react';

import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";


import { PIVOT_KEY } from '../common/consts';

//import styles from './TeamsTracker.module.scss';
import { escape } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import {  Pivot, PivotItem, PivotLinkFormat, PivotLinkSize } from "office-ui-fabric-react/lib/Pivot";
import { PrimaryButton, DefaultButton } from "office-ui-fabric-react/lib/Button";
import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';
//import * as MSGraph from '@microsoft/microsoft-graph-types';
//import { MSGraphClient } from '@microsoft/sp-http';

import  * as uuidv4 from "uuid/v4";
import { AppHeader } from './AppHeader';
import { TeamsContainer } from '../team/TeamsContainer';
import { ChatsContainer } from '../chat/ChatsContainer';

import { ItemsApp } from '../item/ItemsApp';
import { EditorContainer } from '../editor/EditorContainer';
import { ShareContainer } from '../share/ShareContainer';
import { liProperties } from 'office-ui-fabric-react';
import { Account } from '../account/Account';
import { Settings } from '../settings/Settings';
import { AccessTokenKey } from 'msal/lib-commonjs/cache/AccessTokenKey';
import { containerStyle, rowStyle, lineStyle, columnStyle } from "./AppLayout.Style"; 


let graphClient = {};

export  const AppLayout = ({ handleLogin, handleLogout ,accessToken, isAuthenticated }) =>{
      
    const { state , dispatch } = useContext(MessagesContext);  
    const [showTeams, setShowTeams] = useState(true);  
    
    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
    log.info(`@ AppLayout`);

 

  const MyErrorComponent = ({ error }) => {
    log.error(`MyErrorComponent @ AppLayout, error ${error.message}`);
    return <div>Error. Search in Logs for details.</div>;
  };

const renderTeams = (accessToken) => {
  log.info(`renderTeams @ AppLayout`);
  if (!showTeams) return "";
  return (
    <>
      <div style={lineStyle()}></div>
      <div style={containerStyle()}>
        <div style={rowStyle()}>
          <div style={columnStyle()}>
            <ErrorBoundary
              render={() => <TeamsContainer accessToken={accessToken} />}
              renderError={({ error, errorInfo }) => (
                <MyErrorComponent error={error} />
              )}
            ></ErrorBoundary>
          </div>
        </div>
      </div>
    </>
  );
};


const renderChats = (accessToken) => {
  log.info(`renderChats @ AppLayout`);
  //if (!showTeams) return "";
  return (
    <>
      <div style={lineStyle()}></div>
      <div style={containerStyle()}>
        <div style={rowStyle()}>
          <div style={columnStyle()}>
            <ErrorBoundary
              render={() => <ChatsContainer accessToken={accessToken} />}
              renderError={({ error, errorInfo }) => (
                <MyErrorComponent error={error} />
              )}
            ></ErrorBoundary>
          </div>
        </div>
      </div>
    </>
  );
};




const renderItems = () => {
  log.info(`renderItems @ AppLayout`);
  return (
    <>
      <div style={lineStyle()} />
      <ErrorBoundary
        render={() => <ItemsApp />}
        renderError={({ error, errorInfo }) => (
          <MyErrorComponent error={error} />
        )}
      />
    </>
  );
};

 const renderShare = (accessToken) => {
   log.info(`renderShare @ AppLayout`);
   return (
     <>
       <div style={lineStyle()} />
       <ErrorBoundary
         render={() => <ShareContainer accessToken={accessToken} />}
         renderError={({ error, errorInfo }) => (
           <MyErrorComponent error={error} />
         )}
       />
     </>
   );
 };

 const renderSettings = (accessToken) => {
   log.info(`renderSettings @ AppLayout`);
   return (
     <>
       <div style={lineStyle()} />
       <ErrorBoundary
         render={() => <Settings accessToken={accessToken} />}
         renderError={({ error, errorInfo }) => (
           <MyErrorComponent error={error} />
         )}
       />
     </>
   );
 };

  const renderAccount = (
    accessToken,
    handleLogin,
    handleLogout,
    isAuthenticated
  ) => {
    log.info(`renderAccount  @ AppLayout`);
    return (
      <>
        <div style={lineStyle()} />
        <ErrorBoundary
          render={() => (
            <Account
              accessToken={accessToken}
              handleLogin={handleLogin}
              handleLogout={handleLogout}
              isAuthenticated={isAuthenticated}
            />
          )}
          renderError={({ error, errorInfo }) => (
            <MyErrorComponent error={error} />
          )}
        />
      </>
    );
  };

  const renderEdit = () => {
    log.info(`renderEdit @ AppLayout`);
    return (
      <>
        <div style={lineStyle()} />
        <ErrorBoundary
          render={() => <EditorContainer />}
          renderError={({ error, errorInfo }) => (
            <MyErrorComponent error={error} />
          )}
        />
      </>
    );
  };


const handleLinkClicked = (event)=>{
  log.info(`handleLinkClicked  @ AppLayout`);
    const selectedPivotKey = event.props.itemKey
    const _paylod = {
       pivotKey:  selectedPivotKey
    };
    dispatch({ type: "SET_PIVOT_KEY", payload: _paylod })
}
 

return (
  <>
    <AppHeader />
    {isAuthenticated ? (
      <Pivot
        linkFormat={PivotLinkFormat.tabs}
        linkSize={PivotLinkSize.large}
        selectedKey={state.pivotKey}
        onLinkClick={(event) => {
          handleLinkClicked(event);
        }}
      >
        <PivotItem headerText="Channels" itemKey={PIVOT_KEY.TEAMS}>
          {renderTeams(accessToken)}
        </PivotItem>
        <PivotItem headerText="Chats" itemKey={PIVOT_KEY.CHATS}>
          {renderChats(accessToken)}
        </PivotItem>
        <PivotItem headerText="Items" itemKey={PIVOT_KEY.ITEMS}>
          {renderItems()}
        </PivotItem>
        <PivotItem headerText="Edit" itemKey={PIVOT_KEY.EDIT}>
          {renderEdit()}
        </PivotItem>
        <PivotItem headerText="Share" itemKey={PIVOT_KEY.SHARE}>
          {renderShare(accessToken)}
        </PivotItem>
        <PivotItem headerText="Settings" itemKey={PIVOT_KEY.SETTINGS}>
          {renderSettings(accessToken)}
        </PivotItem>
        <PivotItem headerText="Account" itemKey={PIVOT_KEY.ACCOUNT} >
          {renderAccount(
            accessToken,
            handleLogin,
            handleLogout,
            isAuthenticated
          )}
        </PivotItem>

      </Pivot>
    ) : (
      
    
    <Pivot
      linkFormat={PivotLinkFormat.tabs}
      linkSize={PivotLinkSize.large}
      selectedKey={state.pivotKey}
      onLinkClick={(event) => {
        handleLinkClicked(event);
      }}
    >
      <PivotItem headerText="Account" itemKey={PIVOT_KEY.ACCOUNT}>
        {renderAccount(accessToken, handleLogin, handleLogout, isAuthenticated)}
      </PivotItem>
    </Pivot>
 
    )}
  </>
)
    }
